const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
const onlyNumbers = /^\d+$/
const alphabetsWhiteSpace = /^[a-zA-Z ]*$/
const alphaNumericUnderscore = /^[A-Za-z0-9_]+$/
const passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/


export const emailValidator = (email) => {
    if (emailRegex.test(email)) {
        return true;
    } else {
        return false;
    }
}

export const numberOnChangeValidator = (no) => {
    if (onlyNumbers.test(no)) {
        return true;
    } else {
        return false;
    }
}

export const alphabetsWhiteSpaceValidator = (text) => {
    if (alphabetsWhiteSpace.test(text)) {
        return true;
    } else {
        return false;
    }
}

export const alphaNumericUnderscoreValidator = (text) => {
    if (alphaNumericUnderscore.test(text)) {
        return true;
    } else {
        return false;
    }
}

export const passwordValidator = (password) => {
    if (passwordRegex.test(password)) {
        return true;
    } else {
        return false;
    }
}

export const ageEighteenValidator = (date) => {
    let birthday = new Date(date);
    var ageDifMs = Date.now() - birthday.getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch

    if (Math.abs(ageDate.getUTCFullYear() - 1970) >= 18) {
        return true;
    } else {
        return false;
    }
}

export const getYearDiff = (dateOne, dateTwo) => {
    return dateOne.diff(dateTwo, 'years');
}

export const removeMinus = (amount) => {
    if(amount?.includes('-')) return amount.replace('-','')
        return ''
}

export const getErrorMessage = (error) => {
    if(error?.response?.data?.message) {
        return error?.response?.data?.message
    } else if(error?.response?.data == '') {
        return error?.message
    } else if(error?.response?.data?.error) {
        return error?.response?.data?.error
    } else {
        return "something went wrong"
    }
}

// export const floatRegex = /^(\d+)?(\.\d+)?$/;
export const floatRegex = /^\d*\.?\d*$/;
export const twoDecimalRegex = /^\d*\.?\d{0,2}$/;
export const alphanumericRegex = /^[a-zA-Z0-9\s]*$/;
export const lettersOnlyRegex = /^[a-zA-Z\s]*$/;
export const numberRegex = /^[0-9]*$/;
export const allowAllExceptAngleBrackets = /^[^<>]*$/;

export const isRead = (notification) =>  notification?.userNotificationStatuses?.[0]?.status?.toLowerCase() == "read";

// export function calculatePercentageAmount(netInvestedValue, percentProfitLoss) {
//   const invested = parseFloat(netInvestedValue);
//   const percent = parseFloat(percentProfitLoss);
//   console.log("invested ",invested,percent)
//   const profitLoseAmount = (invested * percent) / 100;
//   return profitLoseAmount.toFixed(2)
// }

export function calculatePercentageAmount(netInvestedValue, percentProfitLoss) {
    if(!percentProfitLoss)  return
    const removeMinus = percentProfitLoss?.replace('-','')
    const invested = parseFloat(netInvestedValue);
    const percent = parseFloat(removeMinus);
  const profitLoseAmount = (invested * percent) / 100;
  return profitLoseAmount.toFixed(2)
}

export const maskToken = (token) => {
  if (!token) return '-';
  if (token.length <= 8) return '****';
  return `${token.slice(0, 3)}****${token.slice(-3)}`;
};

